import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "jw_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const add = (item) => {
        setItems((prev) => {
            const f = prev.find((p) => p.id === item.id);
            if (f) return prev.map((p) => (p.id === item.id ? { ...p, qty: p.qty + 1 } : p));
            return [...prev, { ...item, qty: 1 }];
        });
    };
    const remove = (id) => setItems((prev) => prev.filter((p) => p.id !== id));
    const setQty = (id, qty) =>
        setItems((prev) =>
            qty <= 0 ? prev.filter((p) => p.id !== id) : prev.map((p) => (p.id === id ? { ...p, qty } : p)),
        );
    const clear = () => setItems([]);

    const subtotal = useMemo(
        () => items.reduce((s, i) => s + Number(i.price) * i.qty, 0),
        [items],
    );
    const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

    return (
        <CartContext.Provider
            value={{ items, add, remove, setQty, clear, subtotal, count, open, setOpen }}
        >
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    const ctx = useContext(CartContext);
    if (!ctx) throw new Error("useCart must be used inside CartProvider");
    return ctx;
}
